'use client';
import type { CSSProperties, ReactElement } from 'react';
import type { FlowchartIcon } from './flowchart-constants';
import type { FlowchartLabelOrigin } from './parse-mermaid-flowchart';
import { FlowchartNodeLabel } from './FlowchartNodeLabel';
import { FlowchartShapeIcon } from './flowchart-shape-icons';
import { FlowchartUnresolvedOverlay } from './FlowchartUnresolvedOverlay';
const ICON_SIZE = 17;
const LABEL_GAP = 5;
const CONTENT_STACK_STYLE: CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: LABEL_GAP,
    width: '100%',
    pointerEvents: 'none',
};
export interface FlowchartNodeContentProps {
    accent: string;
    icon: FlowchartIcon | null;
    iconColor: string;
    isUnresolved: boolean;
    label: string;
    labelOrigin: FlowchartLabelOrigin;
    textColor: string;
}
export function FlowchartNodeContent({ accent, icon, iconColor, isUnresolved, label, labelOrigin, textColor, }: FlowchartNodeContentProps): ReactElement {
    return (
      <div style={CONTENT_STACK_STYLE}>
        {icon ? <FlowchartShapeIcon icon={icon} color={iconColor} size={ICON_SIZE}/> : null}
        <FlowchartNodeLabel label={label} labelOrigin={labelOrigin} textColor={textColor}/>
        {isUnresolved ? <FlowchartUnresolvedOverlay accent={accent}/> : null}
      </div>
    );
}
